export const UPDATE_USER_LOCATION = "UPDATE_USER_LOCATION"
export const SET_USER_LOCATION_LOAD = "SET_USER_LOCATION_LOAD"
export const SET_USER_LOCATION_ERROR = "SET_USER_LOCATION_ERROR"

export const update = (location) => {
  return {
    type: UPDATE_USER_LOCATION,
    location
  }
}

export const setLoad = (load) => {
  return {
    type: SET_USER_LOCATION_LOAD,
    load
  }
}

export const setError = (error) => {
  return {
    type: SET_USER_LOCATION_ERROR,
    error
  }
}

export default {
  update,
  setLoad,
  setError
}
